<template>
  <div class="room-box elevation-2" style="position: relative;">
    <v-layout row wrap>
      <v-flex xs4>
        <span>SALA: <strong class="text-uppercase">{{ roomName }}</strong></span>
      </v-flex>
      <v-flex xs4>
        <span>UNIDADE: <strong>{{ roomUnit }} - {{ roomUnitCode }}</strong></span>
      </v-flex>
      <v-flex xs4>
        <span>POSIÇÃO: <strong>{{ roomPosition }}</strong></span>
      </v-flex>
      <v-flex xs12 v-if="exclusionError" @click="exclusionError = false">
        <span class="red--text"><strong>ESTA SALA NÃO PODE SER EXCLUIDA! HÁ DEPENDENCIAS...</strong></span>
      </v-flex>
    </v-layout>
    <span @click.stop="deleteRoom()" class="delete-button"><i class="fas fa-trash-alt"></i></span>
    <span @click.stop="editingRoom = true" class="edit-button"><i class="fas fa-edit"></i></span>

    <v-dialog v-model="editingRoom" width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>EDIÇÃO DE SALA.</v-card-title>
        <v-card-text>
          <v-form v-model="editValidation" ref="editRoomForm" lazy-validation>
            <v-text-field v-model="editData.name" :counter="46" label="NOME, EX: ZEUS, HÉRCULES, 19º..." :rules="nameRules" required box/>
            <v-text-field v-model="editData.position" :counter="6" label="POSIÇÃO DA SALA NA LISTAGEM." :rules="positionRules" required box/>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="editingRoom = false">SAIR</v-btn>
          <v-btn color="primary" flat @click="saveModifications()">PROSSEGUIR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['room-name', 'room-id', 'room-position', 'room-unit', 'room-unit-code'],
  data() {
    return {
      exclusionError: false,
      editingRoom: false,
      editData: {
        name: this.roomName,
        position: ''
      },
      editValidation: true,
      nameRules: [
        v => !!v || 'NOME REQUERIDO!',
        v => (v && v.length >= 2) || 'NOME NÃO PODE TER MENOS DE 02 CARACTERES!',
        v => (v && v.length <= 46) || 'NOME NÃO PODE TER MAIS DE 46 CARACTERES!',
      ],
      positionRules: [
        v => !!v || 'POSIÇÃO REQUERIDA!',
        v => (v && v.length >= 1) || 'POSIÇÃO NÃO PODE TER MENOS DE 01 CARACTERES!',
        v => (v && v.length <= 6) || 'POSIÇÃO NÃO PODE TER MAIS DE 06 CARACTERES!',
        v => (v && Number.isInteger(Number(v))) || 'O VALOR DEVE SER UM NUMERO!',
      ],
    }
  },
  methods: {
    deleteRoom() {
      this.$http.delete(`classrooms/${this.roomId}`, {}).then(data => {
        this.$emit('reloadRooms')
      }).catch(err => {
        this.exclusionError = true
      })
    },
    saveModifications() {
      if (this.$refs.editRoomForm.validate()) {
        this.$http.put(`classrooms/${this.roomId}`, {roomData: this.editData}).then(data => {
          this.$emit('reloadRooms')
          this.editingRoom = false
        }).catch(err => {

        })
      }
    },
  }
}
</script>

<style scoped>
  .room-box {
    border-left: 10px solid #c4161c;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background-color: #fff;
    padding-left: 20px;
    margin-bottom: 26px;
    cursor: pointer;
  }
  .delete-button {
    position: absolute;
    top: 12px;
    right: 15px;
  }
  .delete-button:hover {
    color: #c4161c;
  }
  .edit-button {
    position: absolute;
    top: 12px;
    right: 36px;
  }
  .edit-button:hover {
    color: #0076FF;
  }
</style>
